import { useContext, useState } from "react";
import { useLoginMutation } from "../api/auth";
import Wrapper from "../utils/msrpWrapper";
import { ChatContext, ChatContextInterface } from "../components/MSRContext";
import Global from "../globals/globals";
import { useNavigate } from "react-router-dom";
import { useWebsocketHook } from "../hooks/useWebsocketHook";
import generateRandomString from "../MSRP/utilities/generators";
import { Card, Label, TextInput, Button } from "flowbite-react";
import { toast } from "react-toastify";
import { setWithExpiry } from "@/utils/storage";

export default function LoginPage() {
  const [emailOrUsername, setemailOrUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState<string | null>(null);
  const navigate = useNavigate();
  const [login] = useLoginMutation();
  const { socketInstance, createSocketInstance } = useWebsocketHook();
  const [isSocketOpen, setIsSocketOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    addRoom,
    handleReceiveFileMessage,
    handleReceiveMessage,
    requestController,
    handleSessionActivation,
    controller,
    setWrapper,
    handleChatListResponse,
    setIsCreator,
    setAvailableRooms,
    notificationController,
    addNotification,
    handleRemoveMessage,
    handleupdateMessage,
    handleaddRequest,
    handleremoveRequest,
    handleaddServerRequest,
    handleremoveServerRequest,
    handlefindServerRequest,
    handlefindRequest,
    handleupdateReqStatusById,
    handleAddMessageHistory,
    setIsAuthenticated,
    clearAllChatRooms,
    handleLeaveFromChat,
    handleAddParticipant,
    handleRemoveParticipant,
    updateMessageStatus,
    updateChatList,
  } = useContext(ChatContext) as ChatContextInterface;

  //TODO: refractor this with msrpcontext
  const handleLogin = async (username: string, password: string) => {
    setLoading(true);
    setLoginError(null);
    const ONE_HOUR = 60 * 60 * 1000;

    try {
      // setLoading(true);
      // console.log("Starting login process...");

      // const wrp = createSocketInstance(username, password, addRoom, handleReceiveFileMessage,
      //   handleReceiveMessage, requestController, notificationController, controller,
      //   handleSessionActivation, handleChatListResponse, setIsCreator, setAvailableRooms,
      //   addNotification, handleRemoveMessage, handleupdateMessage, handleaddRequest,
      //   handleremoveRequest, handleaddServerRequest, handleremoveServerRequest, handlefindServerRequest,
      //   handleLeaveChat, handlefindRequest, handleupdateReqStatusById, handleAddMessageHistory);

      // if (!wrp) {
      //   throw new Error("Failed to create socket instance.");
      // }

      // console.log("Attempting to open socket...");
      // let socketStatus = false;

      // try {
      //   socketStatus = isSocketOpen || (await wrp.openSocket());
      // } catch (socketError) {
      //   setLoading(false);
      //   console.error("Socket open error:", socketError);
      //   throw socketError; // Re-throw to be caught by outer catch
      // }

      // setIsSocketOpen(socketStatus);
      // console.log("Socket Status:", socketStatus);
      const response = await login({
        agent_email_or_username: username,
        agent_password: password,
      }).unwrap();

      localStorage.setItem("userData", JSON.stringify(response));
      console.log("Login successful, response:", response);
      console.log("companyDomain:", response.company_domain);

      Global.companyDomain = "@" + response.company_domain;
      console.log("global companyDomain= ", Global.companyDomain);

      const wrp = createSocketInstance(
        username,
        password,
        response.company_domain,
        addRoom,
        handleReceiveFileMessage,
        handleReceiveMessage,
        requestController,
        notificationController,
        controller,
        handleSessionActivation,
        handleChatListResponse,
        setIsCreator,
        setAvailableRooms,
        addNotification,
        handleRemoveMessage,
        handleupdateMessage,
        handleaddRequest,
        handleremoveRequest,
        handleaddServerRequest,
        handleremoveServerRequest,
        handlefindServerRequest,
        handlefindRequest,
        handleupdateReqStatusById,
        handleAddMessageHistory,
        clearAllChatRooms,
        handleLeaveFromChat,
        handleAddParticipant,
        handleRemoveParticipant,
        updateMessageStatus,
      );
      if (!wrp) {
        throw new Error("Failed to create socket instance.");
      }
      console.log("Opening socket...");
      const socketStatus = await wrp.openSocket();

      if (!socketStatus || typeof socketStatus === "object") {
        location.reload();
        return;
      }
      setIsSocketOpen(true);
      console.log("Authorizing...");
      const authResult = await wrp.authorize();

      if (authResult === 1) {
        console.log("User authorized successfully");
        toast.success("Login successful!", {
          autoClose: 500,
        });
        saveLoginData(username, password, response.company_domain);
        console.log("wrp", wrp);

        localStorage.setItem("wrapper", wrp.toString());
        localStorage.setItem("isAuthentication", "true");
        setWrapper(wrp);
        setIsAuthenticated(true);
        navigate("/");
        finalizeLogin(true);
        while (Global.counter != 1) {
          const messageJson = {
            id: generateRandomString(16),
            type: "request",
            job: "chat-list",
            parameters: {
              "from-name": Global.username + Global.companyDomain,
              "chat-type": "any",
              personal: true,
              "session-status": "both",
            },
          };
          const messageJsonString = JSON.stringify(messageJson, null, 4);
          wrp?.sendMsg(messageJsonString, "application/rechat.cntl+json");

          Global.counter = 1;
        }
      } else {
        throw new Error("User authorization failed");
      }
    } catch (error: any) {
      console.error("Error during login process:", error);
      toast.error("Login failed. Please check your credentials and try again.");
      // Log the full error object for debugging
      setLoginError(
        "Login failed. Please check your credentials and try again.",
      );
      finalizeLogin(false);
      // Optionally show error to user
      // setErrorMessage(error.message);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  // const handleLogin = async () => {
  //   // Skip login logic and directly set the app as authenticated
  //   console.log("Skipping login...");
  //   setIsAuthenticated(true);
  //   navigate("/"); // Redirect to the dashboard or home page
  // };

  const saveLoginData = (
    username: string,
    password: string,
    companyDomain: string,
  ) => {
        const ONE_HOUR = 60 * 60 * 1000;

    Global.companyDomain = "@" + companyDomain;
    console.log("global companyDomain save= ", Global.companyDomain);
    const loginData = {
      host: "127.0.0.1",
      port: 9915,
      username,
      password,
      sessionId: `${Global.sessionId}`,
      serverIp: "127.0.0.1",
      serverPort: 3457,
      loginTimestamp: new Date().getTime(),
      companyDomain,
    };
  localStorage.setItem("wrapperData", JSON.stringify(loginData));

    Global.username = username;
    Global.companyDomain = "@" + companyDomain;

    console.log("sessionID= ", Global.sessionId);
  };

  const finalizeLogin = (isSuccess: boolean) => {
    setLoading(false);
    if (!isSuccess) setLoginError("Login failed. Please try again.");
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!password.trim()) {
      toast.error("Password cannot be empty");
      return;
    }
    if (!emailOrUsername.trim()) {
      toast.error("Email or username cannot be empty");
      return;
    }
    handleLogin(emailOrUsername, password);
  };

  return (
    <div className="flex flex-col items-center justify-center px-6 lg:h-screen lg:gap-y-12">
      <div className="absolute bottom-5 right-5 text-xs text-gray-500 dark:text-gray-400">
        version 2.9.0
      </div>
      <a href="/" className="my-6 flex items-center gap-x-1 lg:my-0">
        <img alt="ICONT" src="/images/icont.png" className="mr-3 h-12" />
      </a>
      <Card
        horizontal
        imgSrc="/images/loginpage.png"
        imgAlt="ICONT"
        className="w-full md:max-w-[1024px] md:[&>*]:w-full md:[&>*]:p-16 [&>img]:hidden md:[&>img]:w-96 md:[&>img]:p-0 lg:[&>img]:block"
      >
        <h1 className="mb-3 text-2xl font-bold dark:text-white md:text-3xl">
          Log in
        </h1>
        <form onSubmit={handleSubmit}>
          <div className="mb-4 flex flex-col gap-y-3">
            <Label htmlFor="username">Your username</Label>
            <TextInput
              id="username"
              name="username"
              placeholder="Email or username"
              type="text"
              value={emailOrUsername}
              onChange={(e) => setemailOrUsername(e.target.value)}
            />
          </div>
          <div className="mb-6 flex flex-col gap-y-3">
            <Label htmlFor="password">Your password</Label>
            <TextInput
              id="password"
              name="password"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {loginError && (
            <p className="mb-4 text-center text-red-500">{loginError}</p>
          )}
          <div className="mb-6">
            <Button
              type="submit"
              className="bg-gradient-to-br from-purple-600 to-blue-500 text-white hover:bg-gradient-to-bl focus:ring-blue-300 dark:focus:ring-blue-800"
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <svg
                    className="mr-2 h-5 w-5 animate-spin text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8H4z"
                    ></path>
                  </svg>
                  Logging in...
                </div>
              ) : (
                "Login"
              )}
            </Button>
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-300">
            Not registered?&nbsp;
            <button
              onClick={() => navigate("/signup")}
              className="text-primary-600 dark:text-primary-300"
            >
              Create account
            </button>
          </p>
        </form>
      </Card>
    </div>
  );
}